import { Link } from "react-router-dom";
import notFoundIllustration from "../assets/notfound-illustration.svg";
import { CONTACT_INFO } from "../config/constants";

export default function NotFound() {
  return (
    <div className="space-y-12">
      <section className="animate-fade-in-up">
        <div className="grid items-center gap-8 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <h1 className="text-5xl font-bold text-white">404</h1>
            <p className="text-3xl font-bold text-white mt-2">Page not found</p>
            <p className="mt-4 text-gray-100 max-w-md">Sorry! The page you're looking for doesn't exist. Let's get you back on track.</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/" className="btn-gold">
                Go back home
              </Link>
              <Link to="/services" className="link-gold">
                Explore Services
              </Link>
            </div>
          </div>
          <div className="flex justify-center lg:justify-end animate-image-bounce-3d">
            <img
              src={notFoundIllustration}
              alt="404 page illustration"
              className="w-full max-w-md rounded-3xl border border-white/30 bg-white/10 backdrop-blur-lg p-3 shadow-lg hover:shadow-2xl transition-all animate-image-bounce-3d"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <section className="card rounded-3xl border border-white/30 bg-white/10 backdrop-blur-lg p-8 hover:shadow-2xl hover:bg-white/20 transition-all duration-300">
        <h2 className="text-2xl font-bold text-white">Still need help?</h2>
        <p className="mt-2 text-gray-100">Check out these useful links or contact us directly.</p>
        <div className="mt-5 flex flex-wrap gap-3">
          <a href={`mailto:${CONTACT_INFO.email}`} className="btn-gold">Email us</a>
              <a href={CONTACT_INFO.whatsappUrl} target="_blank" rel="noreferrer" className="link-gold whatsapp-link">Chat on WhatsApp</a>
        </div>
      </section>
    </div>
  );
}
